module.exports = __webpack_public_path__ + "fd3f923e3111762896086b424dad9953.svg";